import { castToBoolean } from '../../../../../lib/util';
import BaseError from '../../../../../lib/error';

export class MissingField extends BaseError {}

class SimpleFieldController {
  constructor($scope, $q, $translate, $log, Upload, APIService,$timeout, StaffUserService) {
    "ngInject";
    this.$scope = $scope;
    this.$q = $q;
    this.$translate = $translate;
    this.$log = $log;
    this.Upload = Upload;
    this._translations = {};
    this.APIService = APIService;
    this.$timeout = $timeout;
    this.StaffUserService = StaffUserService;
    this.profile = {};
  }

  $onInit() {
    let promises = [];

    if (!this.field) {
      throw new MissingField("Field is required");
    }

    promises.push(
      this._getTranslations(this.translationKeys)
        .then(translations => this._translations = translations)
    );

    return this.$q.all(promises);
  }

  $postLink() {
  }

  get field() {
    return this._field;
  }

  set field(field) {
    this._field = field;
  }

  get translationKeys() {
    return [
      'REQUIRED',
    ];
  }

  get value() {
    return this.field.value;
  }

  set value(value) {
    this.field.value = value;
  }

  set newFile(file) {
    this._newFile = file;
  }

  get newFile() {
    return this._newFile;
  }

  get isEmpty() {
    return this.value === undefined || this.value === null;
  }


  get options() {
    return this.field.options;
  }

  get required() {
    return this.field && castToBoolean(this.field.required);
  }

  get editable() {
    if (this.field.editable) {
      return castToBoolean(this.field.editable);
    }
    return typeof this.field.editable === 'undefined';

  }

  get requiredPlaceholderText() {
    return '';
    let text;
    if (this.required) {
      let s = (this.translations['REQUIRED'] || 'required').toLowerCase();
      text = `(${s})`;
    } else {
      text = '';
    }
    return text;
  }

  get minMaxLengthText() {
    let text = '';
    if (this.field.min_length) {
      let s = 'Min: ' + this.field.min_length + ' ' + (this.translations['CHARACTERS'] || 'characters').toLowerCase() + ' ';
      text += s;
    }
    if (this.field.min_length && this.field.max_length) {
      text += ' / ';
    }
    if (this.field.max_length) {
      let s = 'Max: ' + this.field.max_length + ' ' + (this.translations['CHARACTERS'] || 'characters').toLowerCase();
      text += s;
    }
    return text;
  }

  get translations() {
    return this._translations;
  }

  _getTranslations(translationKeys) {
    return this.$q
      .all(
        translationKeys.map(key => {
          let promise = this.$translate(key);
          return promise.then(translated => {
            return {key, translated};
          });
        })
      )
      .then(translationInfo => translationInfo.reduce((o, info) => {
        o[info.key] = info.translated;
        return o;
      }, {}))
      .catch(err => {
        this.$log.error("Error loading translations:", err);
        return this.$q.reject(err);
      });
  }
  uploadFile(file, invalidFiles, customFieldId) {
   if (file) {
     this.currentlyTransferringFile = file;
     file.upload = this.Upload.upload({
       url: this.APIService.convertPathToURL('/profile_custom_document_upload'),
       data: {
         customFieldId,
         file,
       },
     }).then(
       (response) => {
         this.$timeout(() => {
           this.transferResult = response.data;
           this.value = this.transferResult.document.id;
         });
       },
       (response) => {
         if (response.status > 0) {
           this.errorMsg = response.status + ': ' + response.data;
         }
       },
       (evt) => {
         this.fileTransferProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        }
      );
    }
  }

  get downloadDocumentTemplateURL() {
    let documentUrl = null;
    if (this.field.documents_id) {
      documentUrl = this.APIService.convertPathToURL(`/docs/${this.field.documents_id}`);
    }
    return documentUrl;
  }

  get downloadDocumentURL() {
    let documentUrl = null;
    if (this.field.value) {
      documentUrl = this.APIService.convertPathToURL(`/docs/${this.field.value}`);
    }
    return documentUrl;
  }
}

export default SimpleFieldController;
